import { ThemePerformanceSortHorizon } from '@api';
import { ButtonGroup } from '@design/components/button-group/ButtonGroup';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { useTranslation } from 'react-i18next';

import styles from './HorizonSelector.module.scss';

type PickedThemePerformanceSortHorizon = Extract<
  ThemePerformanceSortHorizon,
  'intraday' | '1w' | '1m' | '3m' | '6m' | '1y'
>;

export const HorizonSelector = () => {
  const { t } = useTranslation(['widget']);

  const { params, setQueryParams } = useQueryParams();
  const activeHorizon = params[queryKeys.themeHorizon];
  const isIntradayChartEnabled = useFlags(state =>
    state.getFeatureFlagState('theme_intraday_chart')
  );

  const horizons: Partial<Record<PickedThemePerformanceSortHorizon, string>> = {
    ...(isIntradayChartEnabled && {
      intraday: t('widget:assetOverview.horizon_intraday'),
    }),
    '1w': t('widget:assetOverview.horizon_1w'),
    '1m': t('widget:assetOverview.horizon_1m'),
    '3m': t('widget:assetOverview.horizon_3m'),
    '6m': t('widget:assetOverview.horizon_6m'),
    '1y': t('widget:assetOverview.horizon_1y'),
  };

  const horizonKeys = Object.keys(horizons);
  const defaultHorizon = isIntradayChartEnabled ? 'intraday' : '1y';

  return (
    <div className={styles.container}>
      <span className={styles.title}>
        {t('themeOverview.themePerformanceTitle')}
      </span>
      <ButtonGroup
        className={styles.buttonGroup}
        data-testid="horizon-btn-group"
        labels={Object.values(horizons)}
        activeIndex={horizonKeys.indexOf(activeHorizon ?? defaultHorizon)}
        onClick={index => {
          const horizon = horizonKeys[index];
          setQueryParams({ [queryKeys.themeHorizon]: horizon });
        }}
      />
    </div>
  );
};
